<script setup lang="ts"></script>

<template>
  <UToaster>
    <UToast />
  </UToaster>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
